import { useRef, useState, type ReactNode } from 'react'
import { triggerDownload } from '../api/download'

/** Recheck authorization and obtain a fresh signed URL only when the user downloads. */
export default function DownloadButton({ resolveFile, children = '下载原文件', className = 'btn', disabled = false }: {
  resolveFile: () => Promise<{ url: string | null; name?: string }>
  children?: ReactNode; className?: string; disabled?: boolean
}) {
  const [busy, setBusy] = useState(false), [error, setError] = useState(''), lock = useRef(false)
  const download = async () => {
    if (lock.current) return
    lock.current = true; setBusy(true); setError('')
    try {
      const file = await resolveFile()
      if (!file.url) throw new Error('文件暂不可下载，请重新打开查看最新状态。')
      triggerDownload(file.url, file.name)
    } catch (caught) { setError(caught instanceof Error ? caught.message : '无法获取文件，请重试。') }
    finally { lock.current = false; setBusy(false) }
  }
  return <span className="file-download-control"><button type="button" className={className} disabled={disabled || busy} onClick={() => void download()}>{busy ? '正在获取文件…' : children}</button>{error ? <span className="file-download-error" role="alert">{error}</span> : null}</span>
}
